import { faEdit } from '@fortawesome/pro-light-svg-icons'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import location from '../../../../../../../utils/globals/locations'
import { useNavigate } from 'react-router-dom'
import { getAntiUnsave, getUserInfo } from '../../../../../../../utils/reducers/getters'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { useCallback } from 'react'
import { showAntiUnsaveModal } from '../../../../../../../utils/reducers/reduxDispatch'

interface SellerDataTPVDSBProps { 
    title: string
    completeData: TPVOrderData | null;
}

const SellerDataTPVDSB: React.FC<SellerDataTPVDSBProps> = ({ title, completeData }) => {
    const { t } = useTwinTranslation()
    const employee = getUserInfo()?.Employee
    return (
        <div className='flex flex-auto flex-col gap-20 overflow-hidden'>
            <div className='flex flex-wrap flex-row justify-between gap-8'>
                <h3>{title}</h3>
                <EditSellerButton EmployeeId={employee?.id}/>
            </div>
            <div className='flex flex-row flex-wrap gap-10 max-w-full'>
                <div className='flex-auto regular16 mb-5 twin_elipsis'>{employee?.fullname_short}</div>
                <div className='flex flex-row flex-wrap flex-auto gap-10 justify-between'>
                    <CustomSellerDetailsTextField label={t('code', 'Código')} value={employee?.code || t('withoutCode', 'Sin código')} />
                    <CustomSellerDetailsTextField label={t('workingCenter', 'Centro de trabajo')} value={completeData?.cashRegister?.WorkingCenter?.name} />
                    {completeData?.cashRegister?.WorkingCenterStation?.id ? <CustomSellerDetailsTextField label={t('workStation', 'Puesto')} value={completeData?.cashRegister?.WorkingCenterStation?.name} /> : null}
                </div>
            </div>
        </div>
    )
}

interface EditSellerButtonProps extends EditSellerButtonLogicProps {
}

const EditSellerButton: React.FC<EditSellerButtonProps> = ({ EmployeeId }) => {
    const { handleEditSeller } = useEditSellerButtonLogic({EmployeeId})
    if (EmployeeId) {
        return (
            <div className='text-green-43 mt-3 cursor-pointer' onClick={handleEditSeller}>
                <TwinIcon icon={faEdit} className='mr-10' />
                <TwinTrans transKey='editData'>Editar Datos</TwinTrans>
            </div>
        )
    }
    return null
}

interface EditSellerButtonLogicProps {
    EmployeeId?: number
 }

const useEditSellerButtonLogic = ({ EmployeeId }: EditSellerButtonLogicProps) => {
    const navigate = useNavigate()
    const handleEditSeller = useCallback(() => {
        const errors = getAntiUnsave()
        if (Object.keys(errors).length) {
            showAntiUnsaveModal(() => {
                navigate(location?.employees + '/' + EmployeeId + '/main')
            })
        } else {
            navigate(location?.employees + '/' + EmployeeId + '/main')
        }
    }, [EmployeeId, navigate])
    return { handleEditSeller }
}

interface CustomSellerDetailsTextFieldProps {
    label: string
    value?: string
}

const CustomSellerDetailsTextField: React.FC<CustomSellerDetailsTextFieldProps> = ({ label, value }) => {
    return (
        <div className='flex flex-row gap-x-10 items-center'>
            <span className='light12 text-gray-51'>{label}</span>
            <span className='regular14 overflow-hidden' >{value}</span>
        </div>
    )
}

export default SellerDataTPVDSB
